import { RegionSelector } from './region-selector'
import { Link } from '@remix-run/react'

const Header = () => {
    return (
        <header className='bg-white relative z-[1] border-b-companyGray border-b-thin py-4'>
            <div className='mx-auto flex justify-between items-center px-5'>
                <Link to='/'>
                    <img
                        src='/BCIC-Logo-Jamaica.png'
                        alt='BCIC Jamaica Logo'
                        className='h-14'
                    />
                </Link>

                <RegionSelector />
            </div>
        </header>
    )
}

export default Header
